import * as React from "react";

type DatasetVersionTableContextValue = {
  page: number;
  setPage: (page: number) => void;
};

export const DatasetVersionTableContext =
  React.createContext<DatasetVersionTableContextValue>({
    page: 0,
    setPage: () => {},
  });

export const useDatasetVersionTableContext = () =>
  React.useContext(DatasetVersionTableContext);
